const configLicensing = {
    acceptTermsCheckmark: false,
    watermarkTimeout: 30001,
    licensing: false,
    shareMode: 'openDownload',
    partnerLinks: []
};

const configAssetPortal = {
    watermarkTimeout: 30000,
    licensing: false,
    supportLink: '',
    allowSubmissions: false,
    submissionLink: '',
    shareMode: 'openDownload',
    progressivePagination: false,
    partnerLinks: [],
    acceptTermsCheckmark: false
};

module.exports = {};

if ( 'production' === process.env.NODE_ENV ) {
    if ( 'licensing' === process.env.PRODUCT ) {
        module.exports = configLicensing;
    }
    if ( 'assetportal' === process.env.PRODUCT ) {
        module.exports = configAssetPortal;
    }
}



// WEBPACK FOOTER //
// ./app/config.js